import i18n from "i18next"
import { initReactI18next } from "react-i18next"

import translationENG from "./locales/eng/translation.json"
import translationZH from "./locales/zh/translation.json"

// the translations - Only English and Chinese
const resources = {
  en: {
    translation: translationENG,
  },
  zh: {
    translation: translationZH,
  },
}

// Restore the English admin default, including browsers that saved Thai
// during the previous release. Keep supported, explicitly selected languages.
const savedLanguage = localStorage.getItem("I18N_LANGUAGE")
const language = Object.keys(resources).includes(savedLanguage) ? savedLanguage : "en"
localStorage.setItem("I18N_LANGUAGE", language)
localStorage.removeItem("I18N_THAI_DEFAULT_APPLIED")
document.documentElement.lang = language
i18n.on("languageChanged", nextLanguage => {
  document.documentElement.lang = nextLanguage
})

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: language,
    supportedLngs: Object.keys(resources),
    fallbackLng: "en", // use English if Chinese translation is not available

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export default i18n
